var _rect, _rect2, _rect3, _g, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 920,
    height: 442,
    viewBox: "0 0 920 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 919,
    height: 441,
    rx: 3.5,
    fill: "white",
    stroke: "#FFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_3895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 920,
    height: 344
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 919,
    height: 343,
    rx: 3.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 919,
    height: 343,
    rx: 3.5,
    stroke: "#DADCDF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_3895)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -106.5,
    y: 39.5,
    width: 1106,
    height: 258,
    stroke: "#DADCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.8838 40H982.116",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.8838 83.1426H982.116",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.8838 126.286H982.116",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.8838 169.429H982.116",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.8838 212.571H982.116",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.8838 255.714H982.116",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.8838 298.857H982.116",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.8838 342H982.116",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9829 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.416 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8496 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.283 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.716 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.149 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.583 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.016 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.45 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.883 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.316 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.75 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.183 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.616 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.05 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.483 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.917 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.35 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.783 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.216 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.65 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.083 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.517 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.95 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.383 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.816 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.25 40V340.997",
    stroke: "#D9D9D9",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.8838 304L15.1162 287L48.6162 239L82.1162 258.5L115.616 228L148.616 241L182.116 204.5L215.116 211.5H248.616L281.616 228L315.116 197L348.616 159.5L382.116 184L415.616 85L448.616 96.5L482.616 85L548.116 62L582.116 137L616.116 273H649.116L682.116 282L715.116 228L748.616 179H781.616L814.616 213.5L848.616 127.5H881.616L915.616 83.5L949.116 193.5H982.616",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.3838 260.5L16.1162 274L49.1162 190L82.6162 258.5L116.116 238L149.116 276.5L182.616 186L216.116 235H249.116L282.616 257H315.616L349.116 191L382.616 154H415.116L449.116 72L483.116 84.5L515.616 148L549.116 63L582.616 114.5L616.116 272H648.616L682.616 342.5L715.116 244L749.116 155.5L782.116 213.5",
    stroke: "#8C8C8C",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.616,
    cy: 72.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.616,
    cy: 113.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.616,
    cy: 147.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482.616,
    cy: 84.5,
    r: 4.5,
    fill: "#8C8C8C",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.616,
    cy: 63.5,
    r: 4.5,
    fill: "#8C8C8C",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 615.616,
    cy: 273.5,
    r: 4.5,
    fill: "#8C8C8C",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648.616,
    cy: 273.5,
    r: 4.5,
    fill: "#8C8C8C",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.616,
    cy: 154.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.616,
    cy: 154.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.616,
    cy: 256.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.616,
    cy: 256.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.616,
    cy: 235.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.616,
    cy: 234.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.616,
    cy: 186.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.616,
    cy: 276.5,
    r: 4.5,
    fill: "#8C8C8C",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.616,
    cy: 238.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.616,
    cy: 227.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.616,
    cy: 239.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.616,
    cy: 205.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.616,
    cy: 211.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.616,
    cy: 211.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.616,
    cy: 227.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.616,
    cy: 196.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.616,
    cy: 159.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.616,
    cy: 183.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.616,
    cy: 135.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682.616,
    cy: 281.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 715.616,
    cy: 227.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.616,
    cy: 178.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 782.616,
    cy: 178.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 815.616,
    cy: 213.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 848.616,
    cy: 127.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882.616,
    cy: 127.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915.616,
    cy: 83.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.616,
    cy: 85.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.6162,
    cy: 190.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.6162,
    cy: 273.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.6162,
    cy: 256.5,
    r: 4.5,
    fill: "#8C8C8C",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.6162,
    cy: 238.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.6162,
    cy: 286.5,
    r: 3.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.616,
    cy: 190.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682.616,
    cy: 342.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 715.616,
    cy: 243.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.616,
    cy: 155.5,
    r: 3.5,
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 782.616,
    cy: 213.5,
    r: 3.5,
    fill: "#8C8C8C"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 39,
    width: 918,
    height: 305,
    fill: "url(#paint0_linear_6_3895)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_3895",
    x1: 460,
    y1: -328.33,
    x2: 460,
    y2: 344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphPlaceholder);
export default __webpack_public_path__ + "static/media/graph-placeholder.7a3318d6a44edc89cb0d4709ef2dbea7.svg";
export { ForwardRef as ReactComponent };